module.exports = __webpack_public_path__ + "img/logo-white.5ef1992a.svg";